import React from 'react';
import './MapPage.scss';
import { BsCheck2 } from 'react-icons/bs';
import { withTranslation } from 'react-i18next';

class MapPage extends React.Component<any, any> {

    render() {
        return (
            <div className="MapPage">
                <div className='headerMapPage'>
                    <div className='btnBack' onClick={this.props.displayRightPage}>
                        <BsCheck2 className='iconBtn'/>
                        <p className='textBtn'>{this.props.t('SampleBikePageMapBtn')}</p>
                    </div>
                    <p className='description'>
                        {this.props.t('SampleBikePageMapDescription1')} <span className='text-important'>{this.props.t('SampleBikePageMapDescriptionImportant1')}</span> {this.props.t('SampleBikePageMapDescription2')} <span className='text-important'>{this.props.t('SampleBikePageMapDescriptionImportant2')}</span> {this.props.t('SampleBikePageMapDescription3')}
                    </p>
                </div>
                
                <iframe
                    className="ushop-map"
                    title="Ushop map"
                    width="100%"
                    height="500"
                    src={"https://apps.ctec.bike/" + this.props.i18n.language + "/ushop/" + this.props.brand}>
                </iframe>
            </div>
        );
    }
}

export default withTranslation()(MapPage);